import React, { useState } from "react";
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import { login } from "../api/adminApi";
import { useNavigate } from "react-router-dom";
import logoImg from "../assets/images/talktokam.webp";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      localStorage.setItem("admin_user", JSON.stringify(data.user));
      localStorage.setItem("admin_token", data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#f8faff" }}>
      <Paper className="glass-card" sx={{ p: 4, width: 400 }}>
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box component="img" src={logoImg} alt="Talktokam" sx={{ height: 56, width: "auto", borderRadius: "8px", mx: "auto", mb: 1.5, display: "block" }} />
          <Typography fontWeight={800} fontSize={20} color="#1e293b">Admin Console</Typography>
          <Typography variant="body2" color="#64748b">Sign in to manage your platform</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField fullWidth size="small" label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            sx={{ mb: 2 }} InputProps={{ sx: { bgcolor: "#ffffff", borderRadius: 2, color: "#1e293b", "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" } } }}
            InputLabelProps={{ sx: { color: "#64748b" } }} />
          <TextField fullWidth size="small" label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            sx={{ mb: 2.5 }} InputProps={{ sx: { bgcolor: "#ffffff", borderRadius: 2, color: "#1e293b", "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" } } }}
            InputLabelProps={{ sx: { color: "#64748b" } }} />
          <Button fullWidth type="submit" variant="contained" disabled={loading}
            sx={{ textTransform: "none", borderRadius: 2, py: 1.2, fontWeight: 700, bgcolor: "#6366f1", "&:hover": { bgcolor: "#4f46e5" } }}>
            {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Sign In"}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;
